// The direction starts straight up, however, actually its 270deg
// because the co-ordinate system runs from the top.
class Turtle {

	/**
	 * Create and initialize the turtle code.
	 *
	 * @param {object} ctx The canvas context that we will be drawing on.
	 * @return {void}
	 */
	constructor( ctx, cursorCtx ) {

		this.ctx = ctx;
		this.cursorCtx = cursorCtx;

		this.reset();

		document.addEventListener(
			'run_command',
			() => {
				this.updateParams();
				this.drawTurtle();
			}
		);

		document.addEventListener(
			'run_begin',
			() => {
				this.reset();
			}
		);

	}


	/**
	 * Reset the turtle properties.
	 * We should do this before we draw anything.
	 *
	 * @return {void}
	 */
	reset() {

		this.centerX = this.ctx.canvas.width / 2;
		this.centerY = this.ctx.canvas.height / 2;

		this.home();
		this.pendown();
		this.showcursor();
		this.colour( '#fff' );
		this.setbg( 'black' );

		this.ctx.clearRect(
			0,
			0,
			this.ctx.canvas.width,
			this.ctx.canvas.height
		);

		this.ctx.lineWidth = 2;
		this.ctx.lineCap = 'round';
		this.ctx.imageSmoothingEnabled = false;
		this.ctx.filter = 'url(#remove-alpha)';

		this.fillCheck = [];

		this.params_x = document.getElementById( 'code-position-x' );
		this.params_y = document.getElementById( 'code-position-y' );
		this.params_angle = document.getElementById( 'code-position-angle' );

		this.updateParams();
		this.drawTurtle();

	}


	/**
	 * Go to the 'home' location.
	 * The center of the screen.
	 *
	 * @return {void}
	 */
	home() {

		this.seta( 270 );
		this.moveTo( this.centerX, this.centerY );

	}


	/**
	 * Set the x and y position of the drawing point.
	 *
	 * @param {array} values The x and y positions.
	 * @return {void}
	 */
	setxy( values ) {

		this.moveTo( values[ 0 ], values[ 1 ] );

	}


	/**
	 * Set the x position of the drawing point.
	 *
	 * @param {number} value The x position.
	 * @return {void}
	 */
	setx( value ) {

		this.moveTo( value, this.y );

	}


	/**
	 * Set the x position of the drawing point.
	 *
	 * @param {number} value The x position.
	 * @return {void}
	 */
	sety( value ) {

		this.moveTo( this.x, value );

	}


	/**
	 * Set the current angle.
	 *
	 * @param {number} angle The angle in degrees to rotate the pointer to.
	 * @return {void}
	 */
	seta( angle ) {

		this.angle = degrees_to_radians( angle );

	}


	/**
	 * Set the width of the pen.
	 *
	 * @param {number} size The width.
	 * @return {void}
	 */
	setwidth( size ) {

		size = +size;
		size = Math.max( 0, size );

		this.ctx.lineWidth = size;

	}


	/**
	 * Set the background colour.
	 *
	 * Sets the colour on a background div, so we can easily change the colour
	 * without redrawing everything.
	 *
	 * If the canvas is reset then we clear the canvas and do not fill it with
	 * another colour.
	 *
	 * @param {string} color A valid CSS color.
	 * @return {void}
	 */
	setbg( color ) {

		document.getElementById( 'code-wrapper' ).style.background = color;

	}


	/**
	 * Move forward delta pixels.
	 *
	 * @param {number} delta The distance to move forwad.
	 * @return {void}
	 */
	forward( delta ) {

		const newX = this.x + Math.cos( this.angle ) * delta;
		const newY = this.y + Math.sin( this.angle ) * delta;

		this.moveTo( newX, newY );

	}


	/**
	 * Move backwards delta pixels.
	 *
	 * @param {number} delta The distance to move forwad.
	 * @return {void}
	 */
	backward( delta ) {

		this.forward( delta * -1 );

	}


	/**
	 * Fill the current position.
	 *
	 * @return {void}
	 */
	fill() {

		const { x, y } = this;

		// Convert the hex colour into an encoded one.
		let color = this.ctx.fillStyle;
		color = convertColor.run( color );

		// If the x or y position are out of bounds then quit.
		if ( x < 0 || x > this.ctx.canvas.width || y < 0 || y > this.ctx.canvas.height ) {
			return;
		}

		floodFill.run( this.ctx, Math.round( x ), Math.round( y ), color );

	}


	/**
	 * Move to the specified points. This is used by setxy and friends.
	 * This does not need to be called outside the class.
	 *
	 * @param {number} newX The new x position.
	 * @param {number} newY The new y position.
	 * @return {void}
	 */
	moveTo( newX, newY ) {

		// Store the current values.
		const { x, y, ctx, _penDown } = this;

		// Update the position properties.
		this.x = parseFloat( newX );
		this.y = parseFloat( newY );

		if ( _penDown ) {
			ctx.beginPath();
			ctx.moveTo( x, y );	// Set to old position.
			ctx.lineTo( this.x, this.y ); // Draw to new position.
			ctx.stroke();
		}

	}


	/**
	 * Turn right `angle` degrees.
	 *
	 * @param {number} angle The amount to turn in degrees.
	 * @return {void}
	 */
	right( angle ) {

		let newAngle = this.angle + degrees_to_radians( angle );

		if ( newAngle > 2 * Math.PI ) {
			newAngle -= 2 * Math.PI;
		}

		this.angle = newAngle;

	}


	/**
	 * Turn left `angle` degrees.
	 *
	 * @param {number} angle The amount to turn in degrees.
	 * @return {void}
	 */
	left( angle ) {

		let newAngle = this.angle - degrees_to_radians( angle );

		if ( newAngle < 0 ) {
			newAngle += 2 * Math.PI;
		}

		this.angle = newAngle;

	}


	/**
	 * Change the drawing colour.
	 *
	 * @param {number|string} colour The new colour. Can be in hex or CSS colour name format.
	 * @return {void}
	 */
	colour( colour ) {

		this.ctx.strokeStyle = colour;
		this.ctx.fillStyle = colour;

	}


	/**
	 * Pick a random colour that's not dreary.
	 * Generates colours in HSL.
	 *
	 * @return {string}
	 */
	colourrand() {

		const h = random.integer( 0, 360 );
		const s = random.integer( 50, 100 );
		const l = random.integer( 40, 80 );
		let newcolor = `hsl( ${h}, ${s}%, ${l}% )`;

		this.colour( newcolor );

	}


	/**
	 * Draw an arc.
	 *
	 * @param {number} radius The radius of the arc.
	 * @param {number} angle The angle of the arc in degrees.
	 * @return {void}
	 */
	arc( args ) {

		const radius = args[ 0 ];
		const angle = args[ 1 ];

		this.ctx.beginPath();
		this.ctx.arc(
			this.x,
			this.y,
			radius,
			this.angle,
			this.angle + degrees_to_radians( angle )
		);
		this.ctx.stroke();

	}


	/**
	 * Lift up the pen.
	 *
	 * @return {void}
	 */
	penup() {

		this._penDown = false;

	}


	/**
	 * Put down the pen.
	 *
	 * @return {void}
	 */
	pendown() {

		this._penDown = true;

	}


	/**
	 * Update visible parameters.
	 *
	 * @return {void}
	 */
	updateParams() {

		if ( this.params_x ) {
			this.params_x.innerHTML = this.x.toFixed( 1 );
		}
		if ( this.params_y ) {
			this.params_y.innerHTML = this.y.toFixed( 1 );
		}
		if ( this.params_angle ) {
			this.params_angle.innerHTML = radians_to_degrees( this.angle ).toFixed( 1 );
		}

	}


	/**
	 * Show cursor.
	 *
	 * @return {void}
	 */
	showcursor() {

		document.getElementById( 'code-cursor' ).style.display = 'block';

	}


	/**
	 * Hide cursor.
	 *
	 * @return {void}
	 */
	hidecursor() {

		document.getElementById( 'code-cursor' ).style.display = 'none';

	}


	/**
	 * Draw the turtle.
	 *
	 * This is drawn on a separate layer so that it can easily be shown/ hidden.
	 *
	 * @return {void}
	 */
	drawTurtle() {

		if ( !this.cursorCtx ) {
			return;
		}

		const ctx = this.cursorCtx;

		ctx.clearRect(
			0,
			0,
			ctx.canvas.width,
			ctx.canvas.height
		);

		let { x, y, angle } = this;
		const size = 10;

		// Drawing settings.
		ctx.strokeStyle = 'black';
		ctx.fillStyle = 'white';
		ctx.lineWidth = 1.5;
		ctx.lineCap = 'round';

		ctx.save();

		// Translate the origin of the canvas to the center of the shape.
		ctx.translate( x, y );

		// Rotate the canvas by the desired angle.
		angle = radians_to_degrees( angle ) - 270;
		ctx.rotate( degrees_to_radians( angle ) );

		// Draw the shape.
		ctx.beginPath();
		ctx.moveTo( -size, 0 );
		ctx.lineTo( 0, -size * 2.25 );
		ctx.lineTo( size, 0 );
		ctx.lineTo( -size, 0 );

		ctx.fill();
		ctx.stroke();

		ctx.restore();

	}


	/**
	 * A dummy method to delay the drawing.
	 * The code for this is actually in the runner.js file.
	 *
	 * @return {boolean} Always false.
	 */
	delay() {

		return false;

	}

	/**
	 * Clear the canvas.
	 *
	 * @return {void}
	 */
	clear() {

		this.ctx.clearRect(
			0,
			0,
			this.ctx.canvas.width,
			this.ctx.canvas.height
		);

	}

}
